import { CobaltTheme } from 'themes/cobalt/wds_theme';
import { DefaultTheme } from 'themes/default/wds_theme';
import { DefaultAccessibleTheme } from 'themes/default_accessible/wds_theme';
import { HotColdTheme } from 'themes/hotcold/wds_theme';
import { IceTheme } from 'themes/ice/wds_theme';
import { YellowJacketTheme } from 'themes/yellowjacket/wds_theme';
import { AdminTheme } from './admin/wds_theme';

const themeCollection = {
	'theme-admin': AdminTheme,
	'theme-default': DefaultTheme,
	'theme-default-accessible': DefaultAccessibleTheme,
	'theme-ice': IceTheme,
	'theme-hotcold': HotColdTheme,
	'theme-yellowjacket': YellowJacketTheme,
	'theme-cobalt': CobaltTheme,

};

export const getThemeByName = (name) => themeCollection[name] || DefaultTheme;
